import { instance } from "libs/api";

import { SupportTicketResponse } from "../../aiTickets.types";
import { ApiRoutesSupportTickets } from "../../constants/enums";
import { GetTicketsParams } from "./getTickets.types";

export interface GetTicketsListResponse {
  data: SupportTicketResponse[];
  meta: {
    page: number;
    take: number;
    itemCount: number;
    pageCount: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
  };
}

export const requestGetTickets = async (
  params: GetTicketsParams,
): Promise<GetTicketsListResponse> => {
  return await instance.get(ApiRoutesSupportTickets.Tickets, {
    params,
    // NestJS reads repeated params (`statuses=open&statuses=resolved`); the
    // default axios array format `statuses[]=open` would not match the DTO.
    paramsSerializer: {
      serialize: (query) => {
        const sp = new URLSearchParams();
        Object.entries(query).forEach(([key, value]) => {
          if (value === undefined || value === null) return;
          if (Array.isArray(value)) {
            value.forEach((v) => sp.append(key, String(v)));
          } else {
            sp.append(key, String(value));
          }
        });
        return sp.toString();
      },
    },
  });
};
